import { utils as globeUtils } from "@hscmap/stellar-globe";
import { assert } from '@/utils/error';
type Timer = ReturnType<typeof setTimeout>

export class ImageDataCache {
  private cache = new Map<string, ImageData>()
  private dead = new Set<string>()
  private deleter = new Map<string, Timer>()

  constructor(readonly ttl = 5000) {
  }

  async get(url: string): Promise<ImageData> {
    if (this.dead.has(url)) {
      throw new Error(`404: ${url}`)
    }
    if (this.cache.has(url)) {
      this.setDeleter(url)
      return this.cache.get(url)!
    } else {
      const image = await globeUtils.loadImage(url).catch(() => undefined) as HTMLImageElement | undefined
      if (image) {
        const imagedata = decodeImage(image)
        this.setDeleter(url)
        this.cache.set(url, imagedata)
        return imagedata
      } else {
        this.dead.add(url)
        throw new Error(`404: ${url}`)
      }
    }
  }

  private setDeleter(url: string) {
    this.deleter.has(url) && clearTimeout(this.deleter.get(url)!)
    this.deleter.set(url, setTimeout(() => {
      this.cache.delete(url)
      this.deleter.delete(url)
    }, this.ttl))
  }
}

const decodeImage = (() => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!
  assert(!!ctx)
  canvas.width = 256
  canvas.height = 256
  return (img: HTMLImageElement) => {
    if (canvas.width !== img.width || canvas.height !== img.height) {
      canvas.width = img.width
      canvas.height = img.height
    }
    ctx.drawImage(img, 0, 0)
    return ctx.getImageData(0, 0, canvas.width, canvas.height)
  }
})()
